import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "../context/authContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const CartWishlistContext = createContext();

export const CartWishlistProvider = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [cartItems, setCartItems] = useState([]);
  const [wishlistItems, setWishlistItems] = useState([]);
  const [isWishlistModalOpen, setIsWishlistModalOpen] = useState(false);
  const [isCartModalOpen, setIsCartModalOpen] = useState(false);
  useEffect(() => {
    if (user) {
      const storedCart = localStorage.getItem(`cart_${user.email}`);
      const storedWishlist = localStorage.getItem(`wishlist_${user.email}`);
      setCartItems(storedCart ? JSON.parse(storedCart) : []);
      setWishlistItems(storedWishlist ? JSON.parse(storedWishlist) : []);
    } else {
      setCartItems([]);
      setWishlistItems([]);
    }
  }, [user]);


  useEffect(() => {
    if (user) {
      localStorage.setItem(`cart_${user.email}`, JSON.stringify(cartItems));
    }
  }, [cartItems, user]);

 
  useEffect(() => {
    if (user) {
      localStorage.setItem(`wishlist_${user.email}`, JSON.stringify(wishlistItems));
    }
  }, [wishlistItems, user]);

  
  const addToCart = (item) => {
  if (user) {
    const exists = cartItems.find((i) => i.id === item.id);

    if (exists) {
    navigate("/cartpage");
    } else {
      setCartItems((prev) => [...prev, { ...item, quantity: 1 }]);
      setIsCartModalOpen(true); 
      // navigate("/cartpage");
    }
    return;
  }

  const users = JSON.parse(localStorage.getItem("users")) || [];
  const itemEmail = item?.userEmail || ""; 
  const foundUser = users.find((u) => u.email === itemEmail);

  toast.warning(
    foundUser ? "Please login to continue." : "Please sign up to continue.",
    {
      position: "top-right",
      autoClose: 1500,
      onClose: () => navigate(foundUser ? "/login" : "/signup"),
    }
  );
};

const updateQuantity = (id, qty) => {
    if (qty < 1) return;
    setCartItems((prev) =>
      prev.map((i) => (i.id === id ? { ...i, quantity: qty } : i))
    );
  };

  const removeFromCart = (productId) => {
    setCartItems((prev) => prev.filter((item) => item.id !== productId));
    toast.success("Removed from cart");
  };

  const isInCart = (productId) => cartItems.some((item) => item.id === productId);

  const toggleWishlist = (product) => {
  if (!user) {
    toast.warning("Please login to manage wishlist");
    setTimeout(() => navigate("/login"), 1000);
    return;
  }

  const exists = wishlistItems.find((item) => item.id === product.id);

  if (exists) {
    setWishlistItems((prev) =>
      prev.filter((item) => item.id !== product.id)
    );
    toast.info("Removed from wishlist");
  } else {
    setWishlistItems((prev) => [...prev, product]);
    setIsWishlistModalOpen(true); 
  }
};



  const isInWishlist = (productId) => wishlistItems.some((item) => item.id === productId);

  return (
    <CartWishlistContext.Provider
      value={{
        cartItems,
        wishlistItems,
        updateQuantity,
        addToCart,
        removeFromCart,
        isInCart,
        toggleWishlist,
        isInWishlist,
        isWishlistModalOpen, 
        setIsWishlistModalOpen,
        isCartModalOpen,
        setIsCartModalOpen
      }}
    >
      {children}
    </CartWishlistContext.Provider>
  );
};

export const useCartWishlist = () => useContext(CartWishlistContext);
